import { useAuth } from "app/context/useAuth";
import { useUser } from "app/context/useUser";
import { Dropdown } from "flowbite-react/lib/esm/components/Dropdown/Dropdown";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSpacesQuery } from "shared/hooks/spaceApi";
import { SubjectParams } from "shared/utils/pagination";
import { setSpaceId, getSpaceId } from "shared/utils/space";

const SpaceSwitcher = () => {
  const { user } = useUser();
  const ability = user.ability;
  const abilitySubject = "Space";
  const { token } = useAuth();
  let activeClass = "text-blue-700 dark:text-white underline";
  let inactiveClass = "text-slate-600 dark:text-slate-400";
  let baseClass = "hover:text-blue-700 cursor-pointer ";

  const { data: spaces, isSuccess } = useSpacesQuery(
    {},
    { skip: ability?.cannot("read", abilitySubject) && !token },
  );
  const spaceId = getSpaceId();
  const [curSpace, setCurSpace] = useState(spaceId);

  return (
    <>
      {isSuccess &&
        Array.isArray(spaces) &&
        token &&
        ability?.can("read", abilitySubject) && (
          <div className="flex w-full justify-center text-center text-sm text-slate-500">
            <Dropdown
              inline
              label={spaces?.find((s) => s.id === curSpace)?.title ?? "Spaces"}
            >
              {spaces?.map((s) => {
                return (
                  <Dropdown.Item
                    key={s.id}
                    onClick={() => {
                      setSpaceId(s.id);
                      setCurSpace(s.id);
                      window.location.reload();
                    }}
                  >
                    {s.title}
                  </Dropdown.Item>
                );
              })}
              {ability?.can("create", abilitySubject) && (
                <NavLink
                  to={SubjectParams.Space.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item className="text-slate-400 dark:text-slate-500">
                    Add space
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          </div>
        )}
    </>
  );
};

export default SpaceSwitcher;
